import React from "react";
import { TextField } from "@material-ui/core";
import { injectIntl } from "react-intl";

export const InputField = ({
  name,
  id,
  className,
  label,
  value,
  error,
  changeHandler,
  helperText,
  isMultiline,
  isRequired,
  max,
  disabled,
  size,
  ...rest
}) => {
  return (
    <TextField
    size={size}
      disabled={disabled}
      className={`my-3 ${className ? className : ""}`}
      name={name}
      id={id}
      type="text"
      label={isRequired ? label + "*" : label}
      inputProps={{ maxLength: max ? max : isMultiline ? 500 : 50 }}
      variant="outlined"
      color={rest.color}
      fullWidth
      value={value}
      error={error}
      helperText={error && helperText}
      onChange={changeHandler}
      multiline={isMultiline}
      rows={isMultiline ? 3 : 1}
      {...rest}
    />
  );
};

export default injectIntl(InputField);
